module.exports = __webpack_public_path__ + "img/indiaarchery_tech_Normal_ua.37f648df.webp";